<template>
    <div
        v-bind="$attrs"
        :aria-selected="isSelected"
        class="ds-single-select-option flex w-full min-w-0 items-start justify-between rounded-lg bg-transparent p-3 text-content-lg focus:bg-semantic-secondary-hover focus:outline-none"
        :class="[
            disabled
                ? 'cursor-not-allowed text-content-disabled'
                : 'cursor-pointer text-content-primary hover:bg-semantic-secondary-hover active:z-50 active:bg-semantic-secondary-pressed',
        ]"
        role="option"
        tabindex="0"
        @click="!disabled && $emit('click', $event)"
    >
        <div class="flex min-w-0 items-start gap-2 break-all">
            <slot name="optionLabelLeading" />
            <slot name="optionLabelMain" />
        </div>

        <slot name="optionLabelTrailing" />
    </div>
</template>

<script setup lang="ts">
import type { DsSingleSelectOptionProps } from './single-select.types';

defineProps<DsSingleSelectOptionProps>();

defineEmits<{
    (e: 'click', event: MouseEvent): void;
}>();
</script>
